import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

// shell/src/main.ts
(window as any).__IS_SHELL__ = true;

initFederation(environment.manifest)
  .catch(err => console.error(err))
  .then(_ => import('./bootstrap'))
  .catch(err => console.error(err));
